import {
    SEND_MAIL_TO_EMAIL,    
  } from '../../actions/stageReady';
  
export default function stageReady(state = {}, action) {
    switch (action.type) {
        case SEND_MAIL_TO_EMAIL:
            return Object.assign({}, state, action.payload);               
        default:
            return state;   
    }
}
  


// WEBPACK FOOTER //
// ./src/reducers/stageReady/index.js